import { render, staticRenderFns } from "./OverviewTableHeader.vue?vue&type=template&id=764cb790"
import script from "./OverviewTableHeader.vue?vue&type=script&lang=js"
export * from "./OverviewTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports